import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class TeachersTrainingAidList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "TeachersTrainingAidList"}
                {...props}
                columns={{
                    "name": {header: 'Név', width: 3, sortable, filterable},
                    "product.name": {header: 'Termék neve', width: 3, sortable, filterable},
                    "school_year": {header: 'Osztály', width: 3, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TeachersTrainingAidList;
